import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'nationality_foreign_migrant_worker_status_factored_into_hiring'

export const dataPointDefinition = {
  retracedId: 'nationality_foreign_migrant_worker_status_factored_into_hiring',
  name: 'Nationality / Foreign Migrant Worker Status factored into hiring decisions and not in line with legal requirements',
  description: 'Consult applicable legal requirements before answering this question. ',
  meta: {
    slcpMeta: {
      key: 'rh-dis-31',
      number: 'RH-DIS-4-12',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'rh-dis-31', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34220,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
